<ng-template let-entity="entity" #actionsTemplate>
  <a (click)="openDeleteRFIDDialog(entity)" id="delete_rfid" *ngIf="config?.isDeleteButtonVisible && entity.userId == null" class="btn btn-sm btn-yellow me-1" ngbTooltip="RFID-Karte löschen">
    <app-svg source="icons/feather/trash" height="18"></app-svg>
  </a>

  <a (click)="openEditDialog(entity);" id="edit_rfid" class="btn btn-sm btn-yellow">
    <span ngbTooltip="RFID-Karte bearbeiten">
      <app-svg source="icons/feather/edit" height="18"></app-svg>
    </span>
  </a>
</ng-template>
<div class="clearfix">
  <form class="float-start">
    <div i18n="@@Search" style="min-width:200px;">
      <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
    </div>
  </form>
  <div class="float-end mb-1 btn-group">
    <!--<button class="btn btn-warning ms-1" id="scan_rfid" data-bs-toggle="modal" (click)="openScanDialog()" i18n-ngbTooltip="@@ScanRfidCardTooltip" >
      <app-svg source="icons/feather/radio" height="18"></app-svg>
      <span class="d-none d-md-inline" i18n="@@ScanRfidCardsButton">&nbsp;&nbsp;RFID-Karte anlernen</span>
    </button>-->
    <button href="#" class="btn btn-yellow ms-1" id="add_rfid" data-bs-toggle="modal" [routerLink]="['create']" [disabled]="isSupporter">
      <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
      <span class="d-none d-md-inline" i18n="@@AddRfidCardsButton">&nbsp;&nbsp;RFID-Karte hinzufügen</span>
    </button>
  </div>
  </div>
  <div *ngIf="tableReady">
    <app-table [table]="table"></app-table>
  </div>

  <div *ngIf="!tableReady" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
    </div>
  </div>

  <router-outlet></router-outlet>
